import React, { useState, useEffect } from 'react';
import NumberFormat from 'react-number-format';
import { format, parseISO} from "date-fns";

import { classNames } from 'components/utils';
import { getMonthName } from 'utils';
import { getTopVideos } from 'api/reports';
import { useTranslation } from 'react-i18next';

const TopVideos = ({ uid, startMonth, startYear, endMonth, endYear }) => {
  const { t } = useTranslation();
  const monthName = getMonthName(startMonth);
  const [loading, setLoading] = useState(false);
  const [topVideos, setTopVideos] = useState();

  const header = [
    {'key': 'video_title', 'label': t('Video Title')},
    {'key': 'video_id', 'label': t('Video ID')},
    {'key': 'estimated_revenue', 'label': t('Total Estimated Earnings')},
    {'key': 'views', 'label': t('Views')},
  ]

  useEffect(() => {
    if(uid) {
      setLoading(true);
      getTopVideos(uid, startYear, startMonth, startYear, startMonth).then((res) => {
        setTopVideos(res?.data?.data);
        setLoading(false);
      });
    }
  }, [uid]);

  const sortedData = topVideos?.sort((a,b) => b.estimated_revenue - a.estimated_revenue);

  const stats = [
    { name: 'Total Estimated Earnings', stat: sortedData?.reduce((accumulator, object) => {
      return accumulator + parseFloat(object.estimated_revenue);
    }, 0)},
    { name: 'Total Views', stat: sortedData?.reduce((accumulator, object) => {
      return accumulator + parseInt(object.views);
    }, 0)},
  ]

  return (<>
    <div className="mb-6">
      <div className="text-3xl font-bold tracking-tight text-blue-gray-900">
        {('Top 100 Earning Videos for')} <span className="text-blue-800">{t(monthName)} {startYear}</span>
      </div>
      {/* {topVideos && <p className="mt-1 max-w-3xl text-md text-gray-500">
        Data as of {format(parseISO(topVideos[0].created), "MMMM d, yyyy pppp")}
      </p>} */}
    </div>

    <div className="mb-6">
      <dl className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
        {stats.map((item) => (
          <div key={item.name} className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
            <dt className="truncate text-sm font-medium text-gray-500">{item.name}</dt>
            <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
              <NumberFormat
                value={item.name === "Total Estimated Earnings" ? parseFloat(item.stat).toFixed(2) : item.stat}
                displayType={'text'}
                thousandSeparator={true}
                prefix={item.name === "Total Estimated Earnings" && '$'}
              />
            </dd>
          </div>
        ))}
      </dl>
    </div>

    <div className="overflow-hidden bg-white shadow sm:rounded-lg mb-6">
      <div className="border-t border-gray-200">
        <table className="min-w-full divide-y divide-gray-300">
          <thead className="bg-gray-50">
            <tr>
              {header.map((k, idx) => {
                return (
                  <th key={k.key} scope="col"
                    className={
                      classNames(
                        idx === 0 ? 'pl-4 sm:pl-6' : '',
                        "py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
                      )
                    }
                  >
                    {k.label}
                  </th>
                )
              })}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {sortedData?.map((rowData, idx) => (
              <tr key={'rowData__' + idx}>
                {header.map((k, kIdx) => {
                  return (
                    <td key={'claim_' + idx + '_' + kIdx}
                      className={
                        classNames(
                          k.key === 'video_title' ? 'font-medium pl-4 sm:pl-6' : '',
                          "whitespace-nowrap px-3 py-4 text-sm text-gray-500"
                        )
                      }
                    >
                      {k.key === 'video_title' && rowData.video_title}
                      {k.key === 'video_id' && rowData.video_id}
                      {k.key === 'estimated_revenue' && <NumberFormat
                        value={parseFloat(rowData.estimated_revenue).toFixed(2)}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={'$'}
                      />}
                      {k.key === 'views' && <NumberFormat
                        value={rowData.views}
                        displayType={'text'}
                        thousandSeparator={true}
                      />}
                    </td>
                  )
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>);
}

export default TopVideos;
